import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from "src/@/components/ui/card";
import { Button } from "src/@/components/ui/button";
import Iconify from "src/components/Iconify";

const TemplateMessage = ({ template, isMe, positions = [] }) => {
  const { t } = useTranslation('chat');
  if (!template || !template.components) {
    return null;
  }

  // Normalizar tipos para lidar com variações ("body" vs "BODY")
  const normalizedComponents = Array.isArray(template.components)
    ? template.components.map((component) => ({
        ...component,
        type: typeof component.type === 'string' ? component.type.toUpperCase() : component.type,
      }))
    : [];

  // Extrair componentes do template (case-insensitive via normalização acima)
  const bodyComponent = normalizedComponents.find((c) => c.type === 'BODY');
  const footerComponent = normalizedComponents.find((c) => c.type === 'FOOTER');
  const buttonsComponent = normalizedComponents.find((c) => c.type === 'BUTTONS');

  // Função para substituir variáveis pelos valores do positions
  const substituirVariaveis = (text) => {
    if (!text) return '';
    
    let resultado = text;
    
    
    // Se não há positions, retornar o texto original
    if (!positions || positions.length === 0) {
      console.log('TemplateMessage - Nenhuma position encontrada, retornando texto original');
      return resultado;
    }
    
    // Substituir cada variável individualmente
    for (let i = 0; i < positions.length; i++) {
      const variavel = `{{${i + 1}}}`;
      const valor = positions[i];
      console.log(`TemplateMessage - Substituindo ${variavel} por:`, valor);
      
      if (valor !== undefined && valor !== null && valor !== '') {
        // Usar replace global para substituir todas as ocorrências
        const regex = new RegExp(variavel.replace(/[{}]/g, '\\$&'), 'g');
        resultado = resultado.replace(regex, String(valor));
        console.log(`TemplateMessage - Resultado após substituição de ${variavel}:`, resultado);
      }
    }
    
    console.log('TemplateMessage - Resultado final:', resultado);
    return resultado;
  };

  // Função para renderizar texto com variáveis destacadas (para preview quando não há positions)
  const renderTextWithVariables = (text) => {
    if (!text) return '';
    
    console.log('TemplateMessage - renderTextWithVariables - Texto de entrada:', text);
    
    // Sempre tentar substituir as variáveis primeiro
    const textoSubstituido = substituirVariaveis(text);

    console.log('TemplateMessage - renderTextWithVariables - Texto substituído:', textoSubstituido);
    
    // Se ainda há variáveis após a substituição, mostrar destacadas
    if (textoSubstituido.includes('{{') && textoSubstituido.includes('}}')) {
      return textoSubstituido.split(/(\{\{[^}]+\}\})/).map((part, index) => {
        if (part.match(/\{\{[^}]+\}\}/)) {
          return (
            <span 
              key={index}
            >
              {part}
            </span>
          );
        }
        return part;
      });
    }
    
    // Se não há variáveis, retornar o texto substituído diretamente
    console.log('TemplateMessage - renderTextWithVariables - Retornando texto final:', textoSubstituido);
    return textoSubstituido;
  };

  return (
    <div className={`max-w-[320px] ${isMe ? 'ml-auto' : 'mr-auto'}`}>
      <Card className="bg-white dark:bg-[#222529] border border-gray-200 dark:border-[#383838] shadow-sm dark:shadow-none overflow-hidden">
        {/* Header do Template - Estilo WhatsApp */}

        {/* Conteúdo do Template */}
        <div className="p-4 space-y-4">
          {/* Body */}
          {bodyComponent && (
            <div className="text-sm text-gray-800 dark:text-[#D1D2D3] leading-relaxed whitespace-pre-wrap">
              {renderTextWithVariables(bodyComponent.text)}
            </div>
          )}

          {/* Footer */}
          {footerComponent && (
            <div className="text-xs text-gray-500 dark:text-[#ABABAD] text-center py-3 border-t border-gray-100 dark:border-[#383838] bg-gray-50 dark:bg-[#1a1d21] -mx-4 px-4">
              {footerComponent.text}
            </div>
          )}

          {/* Botões */}
          {buttonsComponent && buttonsComponent.buttons && (
            <div className="space-y-2">
              {buttonsComponent.buttons.map((button, index) => (
                <Button
                  key={index}
                  variant="outline"
                  size="sm"
                  className="w-full text-sm justify-start bg-gray-50 dark:bg-[#1a1d21] hover:bg-gray-100 dark:hover:bg-[#2a2d31] border-gray-200 dark:border-[#383838] text-gray-700 dark:text-[#D1D2D3] font-normal"
                  disabled
                >
                  {button.type === 'QUICK_REPLY' && (
                    <Iconify icon="material-symbols:reply" className="w-4 h-4 mr-2 text-gray-500 dark:text-[#ABABAD]" />
                  )}
                  {button.type === 'URL' && (
                    <Iconify icon="material-symbols:link" className="w-4 h-4 mr-2 text-gray-500 dark:text-[#ABABAD]" />
                  )}
                  {button.type === 'PHONE_NUMBER' && (
                    <Iconify icon="material-symbols:phone" className="w-4 h-4 mr-2 text-gray-500 dark:text-[#ABABAD]" />
                  )}
                  {renderTextWithVariables(button.text)}
                </Button>
              ))}
            </div>
          )}
        </div>

        {/* Rodapé informativo sobre template */}
        <div className="bg-gray-50 dark:bg-[#1a1d21] px-4 py-2 border-t border-gray-100 dark:border-[#383838]">
          <div className="flex items-center justify-between">
            <p className="text-xs text-gray-500 dark:text-[#ABABAD] italic">
              {t('templates.sentByTemplate')}
            </p>

          </div>
        </div>
      </Card>
    </div>
  );
};

export default TemplateMessage;
